export default {
  api: {
    baseUrl: 'https://dev.api.x.makna.ai',
    chatUrl: 'https://dev.api.chat.makna.ai',
    // baseUrl: 'http://localhost:7000',
  },
};
